import {Component,Injectable} from '@angular/core';
import { Headers,URLSearchParams,Response, Http, RequestOptions} from '@angular/http';
import {Observable} from 'rxjs/Rx';
import 'rxjs/Rx';

import { CookieService } from 'angular2-cookie/core';
import * as glob from "./global_url";
import {Logger, Options, Level } from "angular2-logger/core"; // ADD THIS

import { Visitor } from '../model/visitor';
import { VisitorLocation } from '../model/visitorLocation';

@Injectable()
export class MamVisitorService{

    private srv_url:string = glob.srv_url;
    constructor(private http:Http, private cookie : CookieService, private logger : Logger){

    }

  getList(urlPath:string, pageNum:number, rowNum:number, searchKeyword:string, searchValue:string, startDate:string, endDate:string) {
    
    var params = new URLSearchParams();

    params.set('pageNum', String(pageNum));
    params.set('rowNum', String(rowNum));
    if (searchValue != "" && searchValue != null) {
      params.set('searchKeyword', searchKeyword);
      params.set('searchValue', searchValue);
    }
    if (startDate != "" && startDate != null
        && endDate != "" && endDate != null) {
      params.set('startDate', startDate);
      params.set('endDate', endDate);
    }
    return this.get(urlPath, null, params);
  }

  updateVisitor(visitor:Visitor) {
    var url_path = "/visitor";
    return this.put(url_path, visitor.id + "", visitor);
  }

  updateLocationStatus(locationId:number, status:number) {
    var url_path = "/visitor-location";
    
    return this.put(url_path, locationId + "", {id:locationId, excuteStatus:status});
  }

//--------------- Visitor Sync ------------------------------------
pushPolicyFree(device_id:number) {
  var url_path = '/visitor/sync/visitorPush';
  return this.get(url_path, String(device_id), null);
}


//--------------- ExcelExport ------------------------------------

getVisitorLogListExcel(searchKeyword:string, searchValue:string, startDate:string, endDate:string) {
  var url = this.srv_url + "/visitor-log/excel?";
  
  if (searchValue != "" && searchValue != null) {
    url += 'searchKeyword=' + searchKeyword;
    url += '&searchValue=' + searchValue;
  }
  if (startDate != "" && startDate != null
      && endDate != "" && endDate != null) {
    if (searchValue != "" && searchValue != null) {
      url += '&'
    }
    url += 'startDate=' + startDate;
    url += '&endDate=' + endDate;
  }
  window.open(url);
}

getVisitorListExcel(searchKeyword:string, searchValue:string, startDate:string, endDate:string) {
  var url = this.srv_url + "/visitor/excel?";
  
  if (searchValue != "" && searchValue != null) {
    url += 'searchKeyword=' + searchKeyword;
    url += '&searchValue=' + searchValue;
  }
  if (startDate != "" && startDate != null
      && endDate != "" && endDate != null) {
    if (searchValue != "" && searchValue != null) {
      url += '&'
    }
    url += 'startDate=' + startDate;
    url += '&endDate=' + endDate;
  }
  window.open(url);
}



  //------------------------------------------------------------------------------------//
  get(pathUrl:string, pathValue:string, param:URLSearchParams):Observable<any>{
      var url = this.srv_url + pathUrl;
      if(pathValue != null){ url = url + "/" + pathValue}
      let headers = new Headers({ 'content-Type': 'application/json'});
      if(this.cookie.get('xAuth')){
        headers.append('X-Auth-Token', this.cookie.get('xAuth'));
      }
      return this.http.get(url, {search :param, headers:headers}).map((res:Response) => this.getHttpResponse(res));
  }

  post(pathUrl:string,pathValue:string, param:URLSearchParams):Observable<any>{
      var url = this.srv_url + pathUrl;
      if(pathValue != null){ url = url + "/" + pathValue}
      let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
      if(this.cookie.get('xAuth')){
        headers.append('X-Auth-Token', this.cookie.get('xAuth'));
      }
      let options = new RequestOptions({headers:headers});
      return this.http.post(url,param.toString(),options)
              .map((res:Response) => res.json());
  }

  post_requestBody(pathUrl:string, pathValue:string, body:any):Observable<any>{
      var url = this.srv_url + pathUrl;
      if(pathValue != null){ url = url + "/" + pathValue}
      let headers = new Headers({ 'content-Type': 'application/json'});
      if(this.cookie.get('xAuth')){
        headers.append('X-Auth-Token', this.cookie.get('xAuth'));
      }
      let options = new RequestOptions({headers:headers});
      return this.http.post(url, JSON.stringify(body) , options).map((res:Response) => res.json());
  }

  put(pathUrl:string,pathValue:string, body:any):Observable<any>{
      var url = this.srv_url + pathUrl;
      if(pathValue != null){ url = url + "/" + pathValue}

      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      if(this.cookie.get('xAuth')){
        headers.append('X-Auth-Token', this.cookie.get('xAuth'));
      }
      return this.http.put(url,JSON.stringify(body),{headers:headers})
              .map((res:Response) => res.json());
  }

  del(pathUrl:string,pathValue:string,param:URLSearchParams){
      var url = this.srv_url + pathUrl;
      if(pathValue != null){ url = url + "/" + pathValue}
      let headers = new Headers({ 'content-Type': 'application/json'});
      if(this.cookie.get('xAuth')){
        headers.append('X-Auth-Token', this.cookie.get('xAuth'));
      }

      return this.http.delete(url,{search :param, headers:headers})
          .map((res:Response) => {
              res.json();
          });
  }


  // parameter set
  setParamHelper(params:any) : URLSearchParams {
    var p_param = new URLSearchParams();
    for(var key in params)  {
      var val = params[key];
      if(key == 'page' || key == 'max') {
          val = <string> val;
          p_param.set(key, val);
      } else {
        p_param.set(key, val);
      }
    }
    return p_param;
  }

  getHttpResponse(res:Response) : any {
    var http_status = res.status;
    var statusText  = res.statusText;
    if(http_status >= 100 && http_status < 200) {
      return this.get1xxHttpMessage(http_status);
    } else if(http_status >= 200 && http_status < 300) {
      return res.json();
    } else if(http_status >=300 && http_status < 400) {
      return this.get3xxHttpMessage(http_status);
    } else if(http_status >=400 && http_status < 500) {
      return this.get4xxHttpMessage(http_status);
    } else {
      return statusText;
    }
  }

  get1xxHttpMessage(code:number) : any {
    var resultMsg = '';
    switch(code) {
      case 100 : resultMsg = '요청자는 요청을 계속해야 한다. 서버는 이 코드를 제공하여 요청의 첫 번째 부분을 받았으며 나머지를 기다리고 있음을 나타낸다.'; break;
      case 101 : resultMsg = '요청자가 서버에 프로토콜 전환을 요청했으며 서버는 이를 승인하는 중이다.'; break;
      case 102 : resultMsg = '처리'; break;
    }
    return resultMsg;
  }

  get2xxHttpMessage(code:number) : any {
    var resultMsg = '';
    switch(code) {
      case 200 : resultMsg = '서버가 요청을 제대로 처리했다는 뜻이다. 이는 주로 서버가 요청한 페이지를 제공했다는 의미로 쓰인다.'; break;
      case 201 : resultMsg = '성공적으로 요청되었으며 서버가 새 리소스를 작성했다.'; break;
      case 202 : resultMsg = '서버가 요청을 접수했지만 아직 처리하지 않았다.'; break;
      case 203 : resultMsg = '서버가 요청을 성공적으로 처리했지만 다른 소스에서 수신된 정보를 제공하고 있다.'; break;
      case 204 : resultMsg = '서버가 요청을 성공적으로 처리했지만 콘텐츠를 제공하지 않는다.'; break;
      case 205 : resultMsg = '서버가 요청을 성공적으로 처리했지만 콘텐츠를 표시하지 않는다. 204 응답과 달리 이 응답은 요청자가 문서 보기를 재설정할 것을 요구한다(예: 새 입력을 위한 양식 비우기).'; break;
      case 206 : resultMsg = '서버가 GET 요청의 일부만 성공적으로 처리했다.'; break;
      case 207 : resultMsg = ''; break;
      case 208 : resultMsg = ''; break;
      case 226 : resultMsg = ''; break;
    }
    return resultMsg;
  }

  get3xxHttpMessage(code:number) : any {
    var resultMsg = "";
    switch(code) {
      case 300 : resultMsg = '서버가 요청에 따라 여러 조치를 선택할 수 있다. 서버가 사용자 에이전트에 따라 수행할 작업을 선택하거나, 요청자가 선택할 수 있는 작업 목록을 제공한다.'; break;
      case 301 : resultMsg = '요청한 페이지를 새 위치로 영구적으로 이동했다. GET 또는 HEAD 요청에 대한 응답으로 이 응답을 표시하면 요청자가 자동으로 새 위치로 전달된다.'; break;
      case 302 : resultMsg = '현재 서버가 다른 위치의 페이지로 요청에 응답하고 있지만 요청자는 향후 요청 시 원래 위치를 계속 사용해야 한다.'; break;
      case 303 : resultMsg = '요청자가 다른 위치에 별도의 GET 요청을 하여 응답을 검색할 경우 서버는 이 코드를 표시한다. HEAD 요청 이외의 모든 요청을 다른 위치로 자동으로 전달한다.'; break;
      case 304 : resultMsg = '마지막 요청 이후 요청한 페이지는 수정되지 않았다. 서버가 이 응답을 표시하면 페이지의 콘텐츠를 표시하지 않는다. 요청자가 마지막으로 페이지를 요청한 후 페이지가 변경되지 않으면 이 응답(If-Modified-Since HTTP 헤더라고 함)을 표시하도록 서버를 구성해야 한다.'; break;
      case 305 : resultMsg = '요청자는 프록시를 사용하여 요청한 페이지만 액세스할 수 있다. 서버가 이 응답을 표시하면 요청자가 사용할 프록시를 가리키는 것이기도 하다.'; break;
      case 307 : resultMsg = '현재 서버가 다른 위치의 페이지로 요청에 응답하고 있지만 요청자는 향후 요청 시 원래 위치를 계속 사용해야 한다.'; break;
      case 308 : resultMsg = '영구 리다이렉션, RFC에서 실험적으로 승인됨'; break;
    }

    return resultMsg;
  }


  get4xxHttpMessage(code:number) : any {
    var resultmsg = "";
    switch(code) {
      case 400 : resultmsg = "잘못된 요청"; break ;
      case 401 : resultmsg = "이 요청은 인증이 필요하다. 서버는 로그인이 필요한 페이지에 대해 이 요청을 제공할 수 있다."; break ;
      case 402 : resultmsg = "이 요청은 결제가 필요합니다."; break ;
      case 403 : resultmsg = "서버가 요청을 거부하고 있다."; break ;
      case 404 : resultmsg = "서버가 요청한 페이지를 찾을 수 없다"; break ;
      case 405 : resultmsg = "요청에 지정된 방법을 사용할 수 없다."; break ;
      case 406 : resultmsg = "요청한 페이지가 요청한 콘텐츠 특성으로 응답할 수 없다."; break ;
      case 407 : resultmsg = "이 상태 코드는 401(권한 없음)과 비슷하지만 요청자가 프록시를 사용하여 인증해야 한다. 서버가 이 응답을 표시하면 요청자가 사용할 프록시를 가리키는 것이기도 한다."; break ;
      case 408 : resultmsg = "서버의 요청 대기가 시간을 초과하였다."; break ;
      case 409 : resultmsg = "서버가 요청을 수행하는 중에 충돌이 발생했다. 서버는 응답할 때 충돌에 대한 정보를 포함해야 한다. 서버는 PUT 요청과 충돌하는 PUT 요청에 대한 응답으로 이 코드를 요청 간 차이점 목록과 함께 표시해야 한다."; break ;
      case 410 : resultmsg = "서버는 요청한 리소스가 영구적으로 삭제되었을 때 이 응답을 표시한다. 404(찾을 수 없음) 코드와 비슷하며 이전에 있었지만 더 이상 존재하지 않는 리소스에 대해 404 대신 사용하기도 한다. 리소스가 영구적으로 이동된 경우 301을 사용하여 리소스의 새 위치를 지정해야 한다."; break ;
      case 411 : resultmsg = "서버는 유효한 콘텐츠 길이 헤더 입력란 없이는 요청을 수락하지 않는다."; break ;
      case 412 : resultmsg = "서버가 요청자가 요청 시 부과한 사전조건을 만족하지 않는다."; break ;
      case 413 : resultmsg = "요청이 너무 커서 서버가 처리할 수 없다."; break ;
      case 414 : resultmsg = "요청 URI(일반적으로 URL)가 너무 길어 서버가 처리할 수 없다."; break ;
      case 415 : resultmsg = "요청이 요청한 페이지에서 지원하지 않는 형식으로 되어 있다."; break ;
      case 416 : resultmsg = "요청이 페이지에서 처리할 수 없는 범위에 해당되는 경우 서버는 이 상태 코드를 표시한다."; break ;
      case 417 : resultmsg = " 서버는 Expect 요청 헤더 입력란의 요구사항을 만족할 수 없다."; break ;
      case 418 : resultmsg = ""; break ;
      case 420 : resultmsg = ""; break ;
      case 422 : resultmsg = ""; break ;
      case 423 : resultmsg = ""; break ;
      case 424 : resultmsg = ""; break ;
      case 425 : resultmsg = ""; break ;
      case 426 : resultmsg = ""; break ;
      case 428 : resultmsg = ""; break ;
      case 429 : resultmsg = ""; break ;
      case 431 : resultmsg = "요청 헤더 필드가 너무 큼"; break ;
      case 444 : resultmsg = ""; break ;
      case 450 : resultmsg = ""; break ;
      case 451 : resultmsg = ""; break ;
      case 494 : resultmsg = ""; break ;
      case 495 : resultmsg = ""; break ;
      case 496 : resultmsg = ""; break ;
      case 497 : resultmsg = ""; break ;
      case 499 : resultmsg = "클라이언트가 요청을 닫음"; break ;
    }
    return resultmsg;
  }
  get5xxHttpMessage(code:number) : any {
    var resultmsg = "";
    switch(code) {
      case 500 : resultmsg = '서버에 오류가 발생하여 요청을 수행할 수 없다.'; break;
      case 501 : resultmsg = '서버에 요청을 수행할 수 있는 기능이 없다. 예를 들어 서버가 요청 메소드를 인식하지 못할 때 이 코드를 표시한다.'; break;
      case 502 : resultmsg = '서버가 게이트웨이나 프록시 역할을 하고 있거나 또는 업스트림 서버에서 잘못된 응답을 받았다.'; break;
      case 503 : resultmsg = '서버가 오버로드되었거나 유지관리를 위해 다운되었기 때문에 현재 서버를 사용할 수 없다. 이는 대개 일시적인 상태이다.'; break;
      case 504 : resultmsg = '서버가 게이트웨이나 프록시 역할을 하고 있거나 또는 업스트림 서버에서 제때 요청을 받지 못했다.'; break;
      case 505 : resultmsg = '서버가 요청에 사용된 HTTP 프로토콜 버전을 지원하지 않는다.'; break;
      case 506 : resultmsg = ''; break;
      case 507 : resultmsg = '용량 부족'; break;
      case 508 : resultmsg = '루프 감지'; break;
      case 509 : resultmsg = '대역폭 제한 초과'; break;
      case 510 : resultmsg = '확장되지 않음'; break;
      case 511 : resultmsg = '네트워크 인증 필요'; break;
      case 598 : resultmsg = '네트워크 읽기 시간초과 오류, 알 수 없음'; break;
      case 599 : resultmsg = '(네트워크 연결 시간초과 오류, 알 수 없음'; break;
    }
    return resultmsg;
  }

  // getReservedVisitor(page:number, max:number, search:string, like:string, field:string) {
  //   var url_path = '/reserved';
  //   var params = new URLSearchParams();
  //   params.set('page', String(page));
  //   params.set('max', String(max));
  //   params.set('searchString', search);
  //   params.set('searchLike', like);
  //   params.set('searchField', field);
  //   return this.get(url_path, null, params);
  // }

  // insertReservedVisitor(ReservedVisitor :any, flag:number) {
  //   var url_path = '/reserved/addedReservedVisitorForm';
  //   return this.post_requestBody(url_path, String(flag), ReservedVisitor);
  // }

  // checkPhoneNumber(phoneNumber:string) {
  //   var url_path = '/reserved/checkPhoneNumber';
  //   var params = new URLSearchParams();
  //   params.set('phoneNumber', phoneNumber);
  //   return this.get(url_path, null, params);
  // }

  // sendSms(name:string, phoneNumber:string) {
  //   var url_path = '/reserved/sendSms';
  //   var params = new URLSearchParams();
  //   params.set('Name', name);
  //   params.set('phoneNumber', phoneNumber);
  //   return this.get(url_path, null, params);
  // }
  // deleteReservedVisitor(id:number) {
  //   var url_path = '/reserved/del';
  //   return this.del(url_path, String(id), null);
  // }

  // multiDel(ids:string) {
  //   var url_path = '/reserved/multiDel';
  //   var params = new URLSearchParams();
  //   params.set('id', ids);
  //   return this.get(url_path, null, params);
  // }


}



// WEBPACK FOOTER //
// ./src/app/service/mam_visitor_service.component.ts